// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"dcef733d","43":"e9e32244","245":"e48ac192","488":"6b4d018d","633":"9800fe3c","949":"2abbbaef","950":"1d49616a"}[chunkId] + ".chunk.js";
};